var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPedidosIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 46,
    viewBox: "0 0 52 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Shopping Bag 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 123",
    d: "M10.8333 15.4167C10.8333 14.3121 11.7287 13.4167 12.8333 13.4167H39.1666C40.2712 13.4167 41.1666 14.3121 41.1666 15.4167V37.25C41.1666 38.9068 39.8234 40.25 38.1666 40.25H13.8333C12.1764 40.25 10.8333 38.9068 10.8333 37.25V15.4167Z",
    stroke: "#E52823",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 124",
    d: "M32.5 13.4167V8.75C32.5 7.09315 31.1569 5.75 29.5 5.75H22.5C20.8431 5.75 19.5 7.09314 19.5 8.75V13.4167",
    stroke: "#E52823",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 125",
    d: "M19.5 21.0833L19.5 25.75C19.5 27.4069 20.8431 28.75 22.5 28.75L29.5 28.75C31.1569 28.75 32.5 27.4069 32.5 25.75L32.5 21.0833",
    stroke: "#E52823",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPedidosIcon);
export default __webpack_public_path__ + "static/media/pedidos-icon.af579d7b64b46d5208c72039127e7bc4.svg";
export { ForwardRef as ReactComponent };